import BoldDecorator from "./bold/viewer.js";
import { createFontSizeDecorator } from "./font-size/viewer.js";
import ItalicDecorator from "./italic/viewer.js";
import StrikethroughDecorator from "./strikethrough/viewer.js";
import SubscriptDecorator from "./subscript/viewer.js";
import SuperscriptDecorator from "./superscript/viewer.js";
import UnderlineDecorator from "./underline/viewer.js";
const getNodeViewDecorators = (plugins) => {
  const fontSizePluginConfig = plugins?.find(
    (plugin) => plugin.type === "fontSize"
  );
  return [
    BoldDecorator,
    ItalicDecorator,
    UnderlineDecorator,
    createFontSizeDecorator(fontSizePluginConfig),
    StrikethroughDecorator,
    SubscriptDecorator,
    SuperscriptDecorator
  ];
};
export {
  getNodeViewDecorators
};
//# sourceMappingURL=viewer.js.map
